webpackJsonp([915738553496],{

/***/ 76:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _gatsbyLink = __webpack_require__(55);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NarrowContainer = _glamorous2.default.div(function (_ref) {
	  var theme = _ref.theme;
	  return {
	    width: theme.main.maxWidths.text
	  };
	});
	
	var PrivacyPolicy = function PrivacyPolicy() {
	  return _react2.default.createElement(
	    _Section2.default,
	    { css: { paddingTop: "calc(100px + 1rem)" } },
	    _react2.default.createElement(
	      NarrowContainer,
	      null,
	      _react2.default.createElement(
	        "h3",
	        null,
	        "Privacy Policy"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "EXN SIA operates the manta.equipment website, which provides Manta Equipment, ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "the Service"
	        ),
	        "."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "This privacy policy has been compiled to better serve those who are concerned with how their 'Personally Identifiable Information' (PII) is being used online. PII, as described in US privacy law and information security, is information that can be used on its own or with other information to identify, contact, or locate a single person, or to identify an individual in context."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If you choose to use our Service, then you agree to the processing and use of information in relation with this policy. The Personal Information that we process is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You acknowledge that the company or institution through which you have been given access to the Service is the data controller in respect to your PII. The Data Controller controls your personal information, while Manta Equipment is the data processor and only processes your personal information in accordance with the agreement and restrictions put in force by the Data Controller."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The terms used in this Privacy Policy have the same meanings as in our ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/terms" },
	          "Terms of Use"
	        ),
	        ", unless otherwise defined in this Privacy Policy."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Information Processing and Use"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "To provide our Service, we may require you or the Data Controller to provide us with certain personally identifiable information, including but not limited to ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "your full name, and e-mail address"
	        ),
	        ". The information that we process will be used exclusively to send transactional emails and to identify you when using the Service."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "This information is initially processed when you use our Service for the first time, or when imported by the Data Controller, i.e. the Organization(s) you are part of and that elect(s) to use our Service."
	      ),
	      _react2.default.createElement(
	        "h5",
	        null,
	        "Log Data"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We want to inform you that whenever you visit our Service, we collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer\u2019s Internet Protocol (\"IP\") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics."
	      ),
	      _react2.default.createElement(
	        "h5",
	        null,
	        "Data retention"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Data Controller determines how long we will retain your personal information. Typically, this is as long as you are an active member (e.g. student or staff member) within your respective institution or as long as necessary to provide our service to the client, whichever is longer. This duration may vary subject to any legal requirements and tax and accounting rules."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "In some circumstances we may de-identify (anonymise) your personal data, so that it can no longer be associated with you) for research or statistical purposes either requested by the client institution or for internal use within Manta Equopment, in which case we may use this information indefinitely without further notice to you."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "In the case of log data, described in the previous section, the data is retained primarily for security concerns and is retained for a maximum of 6 months."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Your rights"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "As a user of our service, you have rights regarding the processing of your data:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Right of access: "
	            ),
	            "If you wish to see whether any of your information is being processed, and if so, what information it is, you may send us a Subject Access request. We will require photocopies of two pieces of identification and will respond within 30 days of receipt of your request. This request is free of charge. However, we reserve the right to charge you for subsequent requests or to deny a request if technically unfeasible or otherwise excessive in extent."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Right to rectification: "
	            ),
	            "We allow you to update your personal information should it be inaccurate or out of date. However, bear in mind that we rely on the Data Controller to ensure that the PII provided to us is accurate and suggest contacting the Data Controller to ensure consistent changes across other data processors."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Right to be forgotten: "
	            ),
	            "If you wish for your personal information to be deleted from our service, you should inform the Data Controller of your request and once it has been completed, we will de-identify all your data in the service as soon as possible."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "The right to restrict processing: "
	            ),
	            "You can opt-out of your data being processed by informing the Data Controller, althought take note that this will likely mean that you are no longer able to use Manta Equipment."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Cookies"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer\u2019s hard drive."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our website uses cookies to provide the following functionality:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "Handle user authentication via external identity provider systems such as Shibboleth and ActiveDirectory,"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Understand and save user's preferences for future visits, and"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "Distinguish unique visitors for website analytics platforms, such as Matomo."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We try to limit the amount of third party cookies that our Service requires, but require some for better user experience. Below is a full list of potential third-party cookies that we may use:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Facebook Customer Chat"
	            ),
	            ": this cookie is used by the Messenger plugin to allow user-to-service communication on the landing page."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Matomo Analytics"
	            ),
	            ": this cookie allows us to understand how users use the Manta Equipment website and informs us on how to better cater to user preferences."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You have the option to opt-out of receiving cookies from our Service by disabling them in your browser, but by doing so you may not be able to use some portions of our Service."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Service Providers"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may employ third-party companies and individuals due to the following reasons:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "To facilitate our Service;"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "To perform Service-related services; or"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "To assist us in analyzing how our Service is used."
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Security"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We value your trust in providing us your Personal Information, thus we strive to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential. In addition, all sensitive information you supply is encrypted via Secure Socket Layer (SSL) technology."
	      ),
	      _react2.default.createElement(
	        "h5",
	        null,
	        "Fair Information Practices"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur:"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          "We will notify you via email within 7 business days"
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          "We will notify the users via an in-site notification within 7 business days"
	        )
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Links to Other Sites"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Children\u2019s Privacy"
	      ),
	      _react2.default.createElement(
	        "h5",
	        null,
	        "COPPA (Children Online Privacy Protection Act)"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our Services do not address anyone under the age of 13. We do not knowingly collect or process personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Changes to This Privacy Policy"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after posting."
	      ),
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Contact Us"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "If you have any questions regarding our Privacy Policy, please contact us at ",
	        _react2.default.createElement(
	          "strong",
	          null,
	          "support at manta.equipment"
	        ),
	        "."
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Last Edited on 2018-05-24"
	      )
	    )
	  );
	};
	
	exports.default = PrivacyPolicy;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-a56a1ead233e501d2a30.js